/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

import {
    FCFS_TYPE,
    FIRST_COME_FIRST_SERVE_TYPE,
} from '../../../constants/filters/camping';
import { FiltersTypeProps } from '../../../types/filters';
import { CommonFilter } from './CommonFilter';

const FCFS_KEY = FIRST_COME_FIRST_SERVE_TYPE[0].key;

const DATES_REQUIRED_KEYS = [FCFS_KEY];

const DATES_REQUIRED_DESCRIPTIONS = { [FCFS_KEY]: 'Add dates to use this filter' };

export type FirstComeFirstServedProps = {
    /** Selected filter groups */
    fg: string[];
    onChange?: (v: React.ChangeEvent<HTMLInputElement>, k: FiltersTypeProps) => void;
    /**
     * Whether the host has a check-in/check-out date range set. The date fields
     * live in a different place in every host store, so each one derives this
     * itself rather than having this component reach into a store shape it
     * cannot know about.
     */
    hasDates: boolean;
};

export function FirstComeFirstServedFilters({
    fg,
    onChange,
    hasDates,
}: FirstComeFirstServedProps) {
    // Dates are only required to apply the filter, never to clear one that is
    // already applied
    const isDisabled = !hasDates && !fg.includes(FCFS_KEY);

    return (
        <div className="mb-5">
            <CommonFilter
                fg={fg}
                onChange={onChange}
                filters={FCFS_TYPE}
                title="First-Come, First-Served"
                columns={1}
                hasDivider={false}
                disabledKeys={isDisabled ? DATES_REQUIRED_KEYS : undefined}
                descriptions={isDisabled ? DATES_REQUIRED_DESCRIPTIONS : undefined}
            />
        </div>
    );
}

// cSpell:ignore FCFS
